import { useState } from 'react'

export type SiblingEvent<T> = T | null

export interface SiblingEventMutation<T> {
  (arg0: SiblingEvent<T>): void
}

/**
 * Use this to create connections between siblings that have no knowledge of
 * each other but have a common parent.
 *
 * A sibling can listen for a change on the generic event state variable.
 * Another sibling can send an "event update" by updating the state via the
 * hook.
 *
 * The help types SiblingEvent and SiblingEventMutation makes it a bit easier
 * to read the code when sending references through several children.
 */
export const useSiblingEvent = <T,>(): [SiblingEvent<T>, SiblingEventMutation<T>] => {
  const [event, setEvent] = useState<SiblingEvent<T>>(null)

  return [
    event,
    state => {
      setEvent(state)

      setTimeout(() => {
        setEvent(null)
      })
    },
  ]
}
